import * as React from 'react';
import { CardSelectButtonsUI, LoadingButtonUI } from '@makemydeal/dr-activities-common';
import TradePage from '../../../common/components/TradePage/TradePage';
import GTPFlowPageSubtitle from '../GTPFlowPageSubtitle/GTPFlowPageSubtitle';
import config from '../../../store/mmd/config';
import { ILoanBalanceOptionsUIProps } from './LoanBalanceOptionsInterfaces';
import { ButtonText } from '../constants';
import { LOAN_BALANCE_OPTION_TYPES } from '../../../utils';

const FindAutoLoanCard = (props) => {
    const id = LOAN_BALANCE_OPTION_TYPES.FIND_OPEN_AUTO_LOAN;
    const checked = props.selectedLoanBalanceOption === LOAN_BALANCE_OPTION_TYPES.FIND_OPEN_AUTO_LOAN;
    return (
        <CardSelectButtonsUI
            id={id}
            data-testid="find-auto-loan"
            panelId={`panel_${id}`}
            headingText="Find Your Open Auto Loan"
            bodyText="Enter your bank or lender name to find your exact loan amount."
            onClick={() => props.onSelect(LOAN_BALANCE_OPTION_TYPES.FIND_OPEN_AUTO_LOAN)}
            selected={checked}
        />
    );
};

const LoanEstimateCard = (props) => {
    const id = LOAN_BALANCE_OPTION_TYPES.LOAN_ESTIMATE;
    const checked = props.selectedLoanBalanceOption === LOAN_BALANCE_OPTION_TYPES.LOAN_ESTIMATE;
    return (
        <CardSelectButtonsUI
            id={id}
            data-testid="loan-estimate"
            panelId={`panel_${id}`}
            headingText="Estimate Your Loan Balance"
            bodyText="Enter a general estimate of your loan amount."
            onClick={() => props.onSelect(LOAN_BALANCE_OPTION_TYPES.LOAN_ESTIMATE)}
            selected={checked}
        />
    );
};

export const LoanBalanceOptionsUI: React.FC<ILoanBalanceOptionsUIProps> = (props) => {
    const {
        pageTitle,
        pageSubTitle,
        stepperRoutes,
        goToRoute,
        dispatchAnalytics,
        vehicleName,
        goBack,
        removeTradeIn,
        cdlBackButtonClicked,
        cdlCancelTradeInButtonClicked,
        selectedLoanBalanceOption,
        tradeIndex,
        urlPath
    } = props;

    const handleSelectOption = (option: string) => {
        props.onSelectLoanBalanceOption(option);
    };

    const handleContinue = () => {
        props.next(selectedLoanBalanceOption);
    };

    const handleBackButtonClick = () => {
        cdlBackButtonClicked();
        goBack();
    };

    const handleSkipButtonClick = () => {
        cdlCancelTradeInButtonClicked();
        removeTradeIn();
    };

    const renderLoanOptionsForm = (props) => {
        return (
            <div className="loan-options-container">
                <div className="loan-options-form">
                    <div className="loan-options-header-text">
                        <h5>Get a more accurate estimate by calculating your open loan balance.</h5>
                    </div>

                    <div className="card-select-grid">
                        <div className="loan-options-card-row">
                            <FindAutoLoanCard {...props} onSelect={handleSelectOption} />
                            <LoanEstimateCard {...props} onSelect={handleSelectOption} />
                        </div>
                    </div>
                    <div className="action-footer">
                        <LoadingButtonUI
                            buttonText={ButtonText.Continue}
                            disabled={!selectedLoanBalanceOption}
                            id="action_footer_bar_action_button"
                            isSubmit={true}
                            onClick={handleContinue}
                            additionalClassParams="btn btn-primary action-footer-button"
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <TradePage
            headerOnTop
            showCustomTitle
            pageClass="loan-options-page"
            pageTitle={pageTitle}
            pageSubTitle={<GTPFlowPageSubtitle pageSubtitle={pageSubTitle} suffix={vehicleName} tradeIndex={tradeIndex} />}
            renderDisclaimer={null}
            goToRoute={goToRoute}
            dispatchAnalytics={dispatchAnalytics}
            footerProps={{
                showBackButton: true,
                onBackButtonClick: handleBackButtonClick,
                fullWidthLayout: true,
                showSkipButton: true,
                skipButtonText: 'Cancel Trade-in',
                onSkipButtonClick: handleSkipButtonClick
            }}
            stepperRoutes={stepperRoutes}
            showTradeErrorMessage={false}
            staticAssetsConfig={config.staticImages}
            stepLabelVisible={true}
            isStepperClickable={false}
            urlPath={urlPath}
        >
            {renderLoanOptionsForm({ selectedLoanBalanceOption })}
        </TradePage>
    );
};

export default LoanBalanceOptionsUI;
